<template>
  <div class="district-wrapper">
    <div class="tap-container">
      <div v-if="regionHK" @click="toggleTap('HK')" class="tap" :class="{active: activeTap === 'HK'}">
        {{ regionName.HK[$i18n.locale] }}
      </div>
      <div v-if="regionKLN" @click="toggleTap('KLN')" class="tap" :class="{active: activeTap === 'KLN'}">
        {{ regionName.KLN[$i18n.locale] }}
      </div>
      <div v-if="regionNT" @click="toggleTap('NT')" class="tap" :class="{active: activeTap === 'NT'}">
        {{ regionName.NT[$i18n.locale] }}
      </div>
    </div>
    <div class="region-container">
      <region
        v-show="activeTap === 'HK'"
        :region="regionHK"
        :selected-ics="selectedIcs"
        @changeDistrict="$emit('changeDistrict', $event)"
      ></region>
      <region
        v-show="activeTap === 'KLN'"
        :region="regionKLN"
        :selected-ics="selectedIcs"
        @changeDistrict="$emit('changeDistrict', $event)"
      ></region>
      <region
        v-show="activeTap === 'NT'"
        :region="regionNT"
        :selected-ics="selectedIcs"
        @changeDistrict="$emit('changeDistrict', $event)"
      ></region>
      <div class="btn-wrap">
        <button class="btn reset-btn" @click="clear">{{ $t('find.RESET') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import FilterButton from '@/components/Stock/Filters/Button';
import FilterModal from '@/components/Stock/Filters/Modal';
import Region from '@/components/Stock/Filters/Region';

export default {
  props: [
    'selectedIcs',
    'selectedDistricts',
  ],
  components: {
    FilterButton,
    FilterModal,
    Region,
  },
  data() {
    return {
      modalKey: 'district',
      activeTap: 'HK',
      modalActive: false,
      regionName: {
        HK: { zh: '港島區', en: 'Hong Kong Island', gb: "港岛区" },
        KLN: { zh: '九龍區', en: 'Kowloon', gb: "九龙区" },
        NT: { zh: '新界區', en: 'New Territories', gb: "新界区" },
      },
    };
  },
  methods: {
    ...mapActions([
      'toggleModal',
    ]),
    openFilter() {
      this.$emit('open');
      this.modalActive = true;
    },
    closeFilter() {
      this.$emit('close');
      this.modalActive = false;
    },
    toggleTap(tap) {
      this.activeTap = tap;
    },
    mixSelectedFilters(region) {
      if (region && Array.isArray(region.dist18)) {
        return {
          ...region,
          dist18: region.dist18
            .map((d18) => {
              const tmpDistrict = d18.district || [];
              const district = tmpDistrict.map(d => ({
                ...d,
                isChecked: this.selectedDistricts.includes(d.dist_code),
              }));
              return {
                ...d18,
                district,
              };
            }),
        };
      }
      return {};
    },
    clear() {
      const districtActions = [...this.selectedDistricts].reduce((prev, curr) => ({
        ...prev, [curr]: false
      }), {});
      if (Object.keys(districtActions).length > 0) {
        this.$emit('changeDistrict', districtActions);
      }
    }
  },
  computed: {
    ...mapState('districts', {
      regionRawHK: 'regionHK',
      regionRawKLN: 'regionKLN',
      regionRawNT: 'regionNT',
    }),
    regionHK() {
      return this.mixSelectedFilters(this.regionRawHK);
    },
    regionKLN() {
      return this.mixSelectedFilters(this.regionRawKLN);
    },
    regionNT() {
      return this.mixSelectedFilters(this.regionRawNT);
    },
  },
};
</script>

<style scoped>
.district-wrapper {
}

.tap-container {
  display: flex;
  text-align: center;
}

.tap {
  flex: 1 1 auto;
  padding: 7px 10px;
  align-items: center;
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
}

.tap.active {
  border-bottom: 2px solid #7ccfeb;
}

.region-container {
  text-align: left;
  display: flex;
  padding-top: 13px;
  overflow-y: auto;
  padding-bottom: 13px;
  flex-direction: column;
}

.reset-btn, .reset-btn:active {
  outline: none;
  background-color: #f0f0f0;
}

.btn-wrap {
  display: flex;
  justify-content: flex-end;
}
</style>